import { QRCodeCanvas } from './QRCodeCanvas';

export default QRCodeCanvas;
